var _defineProperty = require("/vercel/61480e30/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

module.exports = iterator;

var normalizePaginatedListResponse = require("./normalize-paginated-list-response");

function iterator(octokit, options) {
  var headers = options.headers;
  var url = octokit.request.endpoint(options).url;
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return {
      next: function next() {
        if (!url) {
          return Promise.resolve({
            done: true
          });
        }

        return octokit.request({
          url: url,
          headers: headers
        }).then(function (response) {
          normalizePaginatedListResponse(octokit, url, response); // `response.headers.link` format:
          // '<https://api.github.com/users/aseemk/followers?page=2>; rel="next", <https://api.github.com/users/aseemk/followers?page=2>; rel="last"'
          // sets `url` to undefined if "next" URL is not present or `link` header is not set

          url = ((response.headers.link || "").match(/<([^>]+)>;\s*rel="next"/) || [])[1];
          return {
            value: response
          };
        });
      }
    };
  });
}